<app-user-header class="d-md-none"></app-user-header>
<div class="row m-0 h-100 row-container">


  <div class="col-md-2 pe-0 ps-0 section-side-nav h-100 d-none d-md-block">
    <app-admin-sidebar></app-admin-sidebar>
  </div>
  <div class="col-md-10 big-area p-0">


    <div class="wrapperi">


      <div class="col-12 p-0 row m-0">
        <div class="col-3"></div>
        <div class="col-12 col-md-6 p-0 input-cover mt-4 p-4">
          <div class="col-12 p-0 mt-4">
            <div class="col-12 text-center p-0">
              <h1 class="mt-4">{{texts}}</h1>
              <p class="desc-text"></p>
            </div>
          </div>

          <div id="loader" *ngIf="isLoading" class="loader-container mt-4">
            <div class="loader mx-auto"></div>
            <p class="text-center pt-3">Odota...</p>
          </div>

          <div *ngIf="!isLoading" id="form-container" class="">
            <form class="flex-row add-form" [formGroup]="form" (ngSubmit)="onSubmit()">

              <!-- Yrityksen nimi ja sukunimi -->
              <div class="col-12 row m-0 pt-2">

                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                  <input type="text" placeholder="Yrityksen nimi" formControlName="businessName" id="businessName"
                    class="form-control" [class.invalid-input]="businessName.errors && businessName.touched" required>
                  <label for="businessName">Yrityksen nimi</label>
                  <div class="my-alerts" *ngIf="businessName.invalid && businessName.touched">
                    <p class="mt-2" *ngIf="businessName.errors.required">Yritys on pakollinen</p>
                    <p *ngIf="businessName.errors.businessName"> Vaaditaan kunnollinen yritys</p>
                  </div>
                </div>

              </div>
              <!-- Yrityksen nimi ja sukunimi -->
              <div class="col-12 row m-0 pt-2">

                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                  <input type="text" placeholder="Y-tunnus" formControlName="vatID" id="vatID"
                    class="form-control" [class.invalid-input]="vatID.errors && vatID.touched" required>
                  <label for="vatID">Y-tunnus</label>
                  <div class="my-alerts" *ngIf="vatID.invalid && vatID.touched">
                    <p class="mt-2" *ngIf="vatID.errors.required">Yritys on pakollinen</p>
                    <p *ngIf="vatID.errors.vatID"> Vaaditaan kunnollinen yritys</p>
                  </div>
                </div>

              </div>
              <!-- Yrityksen nimi ja sukunimi -->
              <div class="col-12 row m-0 pt-2">

                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                  <input type="text" placeholder="OVT" formControlName="ovt" id="ovt"
                    class="form-control">
                  <label for="ovt">Verkkolaskuosoite (valinnainen)</label>
                </div>

              </div>
              <!-- Yrityksen nimi ja sukunimi -->
              <div class="col-12 row m-0 pt-2">

                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                  <input type="text" placeholder="Välittäjä" formControlName="operator" id="operator"
                    class="form-control">
                  <label for="operator">Välittäjä (valinnainnen)</label>
                </div>

              </div>
              <!-- Sähköposti -->
              <div class="col-12 row m-0 pt-2">
                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                  <input type="email" placeholder="Formed yhteyshenkilö" formControlName="email" id="email"
                    class="form-control" [class.invalid-input]="email.errors && email.touched" required>
                  <label for="email">Formed yhteyshenkilö sähköposti</label>
                  <div class="my-alerts" *ngIf="email.invalid && email.touched">
                    <p class="mt-2" *ngIf="email.errors.required">email on pakollinen</p>
                    <p *ngIf="email.errors.email"> Vaaditaan kunnollinen businessName</p>
                  </div>
                </div>
              </div>
              <!-- Puhelin -->
              <div class="col-12 row m-0 pt-2">

                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                  <input type="phone" placeholder="Formed yhteyshenkilö Puhelinnumero" formControlName="phone"
                    id="phone" class="form-control" [class.invalid-input]="phone.errors && phone.touched" required>
                  <label for="phone">Formed yhteyshenkilö Puhelinnumero</label>
                  <div class="my-alerts" *ngIf="phone.invalid && phone.touched">
                    <p class="mt-2" *ngIf="phone.errors.required">Formed yhteyshenkilö Puhelinnumero on pakollinen</p>
                    <p *ngIf="phone.errors.phone"> Vaaditaan kunnollinen Formed yhteyshenkilö puhelinnumero</p>
                  </div>
                </div>
              </div>
              <!-- Polkutunniste -->
              <div class="col-12 row m-0 pt-2" *ngIf="!routeID">
                <p class="mb-0">Polkutunniste esim. app.formed.fi/polkutunniste/home</p>
                <p style="color:red">Kiellettyjä: ei saa sisältää api tai admin</p>
                <div class="form-floating mb-2  col-12 col-md-12 p-0">
                  <input type="text" placeholder="Polkutunniste" formControlName="rootID" id="rootID"
                    class="form-control" [class.invalid-input]="rootID.errors && rootID.touched" required>
                  <label for="rootID">Polkutunniste</label>
                  <div class="my-alerts" *ngIf="rootID.invalid && rootID.touched">
                    <p class="mt-2" *ngIf="rootID.errors.required">Polkutunniste on pakollinen</p>
                    <p *ngIf="rootID.errors.rootID"> Vaaditaan kunnollinen Polkutunniste</p>
                  </div>
                </div>
              </div>

              <p>Onko yritys julkinen?</p>
              <div class="form-group ps-2 col-12 row m-0 pb-4">
                <div class=" col-12 col-md-4">
                  <div class="col-12 row mt-2">
                    <div class="col-1 p-0">
                      <input type="checkbox" formControlName="public_leaver" id="public_leaver">
                    </div>
                    <div class="col-9">
                      <p class="text-start m-0">Kyllä</p>
                    </div>
                  </div>

                </div>
              </div>
              <div class="" *ngIf="!routeID">
                <h2 class="mt-2 mb-2">Ensimmäisen käyttäjän tiedot</h2>
                <!--Etu ja suku -->
                <div class="col-12 row m-0 pt-2">

                  <div class="form-floating mb-2 col-12 col-md-6 p-0">
                    <input type="text" placeholder="Etunimi" formControlName="main_firstName" id="main_firstName"
                      class="form-control" [class.invalid-input]="main_firstName.errors && main_firstName.touched"
                      required>
                    <label for="main_firstName">Etunimi</label>
                    <div class="my-alerts" *ngIf="main_firstName.invalid && main_firstName.touched">
                      <p class="mt-2" *ngIf="main_firstName.errors.required">Etunimi on pakollinen</p>
                      <p *ngIf="main_firstName.errors.main_firstName"> Vaaditaan kunnollinen Etunimi</p>
                    </div>
                  </div>
                  <div class="form-floating mb-2 ps-md-2 col-12 col-md-6 p-0">
                    <input type="text" placeholder="Sukunimi" formControlName="main_lastName" id="main_lastName"
                      class="form-control" [class.invalid-input]="main_lastName.errors && main_lastName.touched"
                      required>
                    <label for="main_lastName">Sukunimi</label>
                    <div class="my-alerts" *ngIf="main_lastName.invalid && main_lastName.touched">
                      <p class="mt-2" *ngIf="main_lastName.errors.required">Sukunimi on pakollinen</p>
                      <p *ngIf="main_lastName.errors.main_lastName"> Vaaditaan kunnollinen Sukunimi</p>
                    </div>
                  </div>
                </div>

                <!-- Sähköposti -->
                <div class="col-12 row m-0 pt-2">
                  <div class="form-floating mb-2  col-12 col-md-12 p-0">
                    <input type="email" placeholder="Pääkäyttäjän sähköposti" formControlName="main_email"
                      id="main_email" class="form-control"
                      [class.invalid-input]="main_email.errors && main_email.touched" required>
                    <label for="main_email">Pääkäyttäjän sähköposti</label>
                    <div class="my-alerts" *ngIf="main_email.invalid && main_email.touched">
                      <p class="mt-2" *ngIf="main_email.errors.required">main_email on pakollinen</p>
                      <p *ngIf="main_email.errors.main_email"> Vaaditaan kunnollinen businessName</p>
                    </div>
                  </div>
                </div>
              </div>







              <div class="form-inline mt-2">
                <div class="form-group mb-2 flex-row">
                  <button [disabled]="form.invalid" class="btn btn-formed-main-black w-100"><i
                      class="fas fa-sign-in-alt me-2"></i>{{texts}}</button>
                </div>
              </div>
            </form>

          </div>
        </div>
        <div class="col-3"></div>
      </div>
    </div>
  </div>